// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-shift-date[data-v-1a656706]{display:flex;align-items:center}.job-shift-date__label[data-v-1a656706]{flex-grow:1}.job-shift-date__date[data-v-1a656706]{width:121px;margin-left:.5rem}@media (min-width:960px){.job-shift-date__date[data-v-1a656706]{width:147px}}", ""]);
// Exports
module.exports = exports;
